import { render, staticRenderFns } from "./RoleSetup.vue?vue&type=template&id=67088d6a&"
import script from "./RoleSetup.vue?vue&type=script&lang=js&"
export * from "./RoleSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports